import { Box } from '@mui/material';

/**
 * Wrapper container to display two columns of content
 */
export const TwoColumnBox = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '24px 16px',
      }}
    >
      {children}
    </Box>
  );
};
